export default __webpack_public_path__ + "static/media/thumbs-up-solid.89020a8b.svg";